export type HealthFilterOptions = {
  from: number | null;
  to: number | null;
  isEmpty: boolean;
};

export const filterByHealth = <T extends { health: number | null }>(
  items: T[],
  { from, to, isEmpty }: HealthFilterOptions,
): T[] => {
  if (isEmpty) {
    return items.filter((item) => item.health === null);
  }

  if (from === null && to === null) {
    return items;
  }

  return items.filter((item) => {
    if (item.health === null) return false;
    if (from !== null && item.health < from) return false;
    if (to !== null && item.health > to) return false;
    return true;
  });
};

